import styled from 'styled-components';

import colors from '@utils/colors';
import fonts, { weights } from '@utils/fonts';
import { mq } from '@utils/responsive';
import { Body, Heading } from '@components/type';

export const ButtonWrapper = styled.div`
  margin-top: 32px;
  text-align: center;
`;

export const Caption = styled(Body)`
  margin-bottom: 8px;
  ${mq.gtsm`
    margin-bottom: 24px;
  `}
`;

export const Contact = styled(Body)`
  display: flex;
  flex-direction: column;
  text-align: center;

  ${mq.gtsm`
    display: block;
  `}

  & span {
    display: none;
    margin: 0 8px;
    color: ${colors.B200};

    ${mq.gtsm`
      display: inline-block;
    `}
  }
`;

export const Description = styled.div`
  margin: 4px 0;
  color: ${colors.N600};
  font-family: ${props => fonts(props.theme.locale).SANS};
  font-size: 13px;
  line-height: 18px;
`;

export const Disclaimer = styled(Body)`
  margin-bottom: 8px;
  margin-top: 8px;
  text-align: center;

  & strong {
    font-weight: ${weights.BOLD};
  }

  ${mq.gtsm`
    margin-bottom: 24px;
    margin-top: 24px;
  `}
`;

export const Divider = styled.div`
  width: 186px;
  margin: 32px auto;
  border-bottom: 3px solid ${colors.B100};

  ${mq.gtsm`
    margin: 80px auto;
  `}
`;

export const Estimate = styled(Heading)`
  margin-bottom: 24px;
  color: ${colors.B500};

  ${mq.gtsm`
    margin-bottom: 40px;
  `}
`;
export const EstimateLabel = styled.div`
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  padding: 0 0 10px;
`;
export const MonthlyEstimateContainer = styled.div`
  padding: 28px 0 0 0;
  width: 180px;
  height: 160px;
  text-align: center;
  background-position:center center;
  background-repeat:no-repeat;
  background-size: contain;
  background-image: url(data:image/png;base64,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);
`;
export const MonthlyEstimateIntro = styled.div`
  font-weight: bold;
  font-size: 18px!important;
  text-align: center;
`;
export const MonthlyEstimateRange = styled.div`
  font-size: 32px;
  line-height: 32px;
  font-family: ${props => fonts(props.theme.locale).SANS_CONDENSED};
  font-weight: ${weights.BOLD};
  padding: 4px 0 0;
  color: ${colors.B500};
  text-align: center;
`;

export const MonthlyEstimateLabel = styled.div`
  line-height: 20px;
  font-size: 20px;
  padding: 0 0 10px;
  font-family: ${props => fonts(props.theme.locale).SANS_CONDENSED};
  font-weight: ${weights.BOLD};
  color: ${colors.B500};
  text-align: center;
  text-transform: uppercase;
`;


export const MonthlyEstimateLabelSecond = styled.div`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
`;
export const ContactDetailsContainer = styled.div`
  display: flex;
  font-size: 18px;
  padding: 80px 0 0 0;
`;
export const ContactDetailsHeader = styled.div`
  font-weight: bold;
`
export const ContactDetailsImageWrapper = styled.div`
  flex: 20%;
`;

export const ContactDetailsContent = styled.div`
  padding: 0 0 0 20px;
  font-size: 14px;
  flex: 80%;
`;

export const Fieldset = styled.div`
  width: 100%;

  & > * {
    width: 100%;
  }

  ${mq.gtsm`
    display: flex;

    & > *:not(:last-child) {
      margin-right: 32px;
    }
  `}
`;

export const FormWrapper = styled.div``;

export const Radio = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: 0 8px;
  appearance: none;
  font-size: 16px;
  border: 2px solid ${(props) => (props.checked ? colors.B500 : colors.B100)};
  border-radius: 8px;
  cursor: pointer;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  ${mq.gtsm`
    height: 48px;
  `}
`;

export const Result = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Select = styled.select`
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: 0 8px;
  appearance: none;
  font-size: 16px;
  border: 2px solid ${colors.B100};
  border-radius: 8px;
  cursor: pointer;

  ${mq.gtsm`
    height: 48px;
  `}
`;

export const SelectWrapper = styled.div`
  position: relative;

  & > svg {
    position: absolute;
    top: 0;
    right: 16px;
    bottom: 0;
    height: 16px;
    width: 16px;
    margin: auto 0;
    fill: ${colors.B500};
  }
`;

export const Wrapper = styled.div``;
